module.exports = __webpack_public_path__ + "static/img/hbq0807.3790fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hbq0807.jpg
// module id = apcf
// module chunks = 0